import { useRef, useEffect } from "react";
import { isNotNull } from "./type-guards.js";
import useIsomorphicLayoutEffect from "./use-isomorphic-layout-effect.js";
function useInterval(callback, delay, options = {}) {
  const { when = true, startImmediate = false } = options;
  const savedCallback = useRef();
  useIsomorphicLayoutEffect(() => {
    savedCallback.current = callback;
  });
  useEffect(() => {
    function tick() {
      savedCallback.current?.();
    }
    if (when) {
      if (startImmediate) {
        tick();
      }
      if (isNotNull(delay)) {
        const id = setInterval(tick, delay);
        return () => {
          clearInterval(id);
        };
      }
    }
  }, [delay, when]);
}
export {
  useInterval
};
//# sourceMappingURL=use-interval.js.map
